// extracted by mini-css-extract-plugin
export default {"line_clamp":"branch_gst_card_line_clamp__jQMIT"};